import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { debounce } from '../../cinnamon-core/es/modules/utility/debounce.js';
import withLookup$1 from '../../cinnamon-core/es/components/lookups/withLookup.js';
import { compareParams, getParamsKey } from '../../cinnamon-core/es/modules/utility/params.js';
import ComboBox from './base/ComboBox.js';
import { getLookupCache } from '../../cinnamon-core/es/modules/lookups/selectors.js';
import { lookupRequest } from '../../cinnamon-core/es/modules/lookups/actions.js';

var _excluded = ["lookup", "lookupAction", "lookupParams", "lookupOptions", "lookupCache", "lookupRequest", "debounce", "searchSuggestions", "alwaysShowSuggestionsOnBlur", "alwaysShowSuggestionsOnMount", "onSearch", "requestLookupWhenDisabled", "ref"];

var TypeAheadBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeAheadBase, _React$Component);

  var _super = _createSuper(TypeAheadBase);

  function TypeAheadBase(props) {
    var _this;

    _classCallCheck(this, TypeAheadBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_requestRequired", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "debouncedSearchChange", void 0);

    _defineProperty(_assertThisInitialized(_this), "updateSearchSuggestions", function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var searchSuggestions = _this.props.searchSuggestions;

      if (searchSuggestions || searchSuggestions === "") {
        _this.search("", force);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "canRequestData", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          requestLookupWhenDisabled = _this$props.requestLookupWhenDisabled;
      return !disabled || requestLookupWhenDisabled;
    });

    _defineProperty(_assertThisInitialized(_this), "isValidValue", function (value) {
      return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== "";
    });

    _defineProperty(_assertThisInitialized(_this), "isLoading", function () {
      var _lookupCache$lookupKe, _lookupCache$lookupKe2;

      var _this$props2 = _this.props,
          lookup = _this$props2.lookup,
          lookupCache = _this$props2.lookupCache,
          loading = _this$props2.loading;
      var lookupKey = _this.state.lookupKey;
      if (!lookup) return loading;
      return lookupKey !== undefined && ((_lookupCache$lookupKe = lookupCache[lookupKey]) === null || _lookupCache$lookupKe === void 0 ? void 0 : _lookupCache$lookupKe.loading) && ((_lookupCache$lookupKe2 = lookupCache[lookupKey]) === null || _lookupCache$lookupKe2 === void 0 ? void 0 : _lookupCache$lookupKe2.slowLoading);
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var _lookupData;

      var _this$props3 = _this.props,
          lookup = _this$props3.lookup,
          lookupCache = _this$props3.lookupCache,
          options = _this$props3.options;
      var _this$state = _this.state,
          lookupKey = _this$state.lookupKey,
          previousKey = _this$state.previousKey;
      if (!lookup) return options !== null && options !== void 0 ? options : [];
      var lookupData = undefined;
      if (lookupKey != undefined) lookupData = lookupCache[lookupKey];
      var previousData = undefined;
      if (previousKey != undefined) previousData = lookupCache[previousKey];
      return (_lookupData = lookupData) !== null && _lookupData !== void 0 && _lookupData.loading ? previousData !== undefined && Array.isArray(previousData.response) ? previousData.response : [] : lookupData !== undefined && Array.isArray(lookupData.response) ? lookupData.response : [];
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var lookup = _this.props.lookup;
      var _this$state2 = _this.state,
          lookupKey = _this$state2.lookupKey,
          previousSearch = _this$state2.previousSearch; // get suggestions again if value cleared

      if (previousSearch && !_this.isValidValue(_this.props.value) && _this.isValidValue(prevProps.value)) {
        _this.updateSearchSuggestions(true);
      } // re-request if flagged


      if (lookup && previousSearch !== undefined && _this.canRequestData() && _this._requestRequired) {
        _this.search(previousSearch, true);
      }

      if (!lookup || lookupKey === undefined) return;
      var prevData = prevProps.lookupCache[lookupKey] || {};
      var currentData = _this.props.lookupCache[lookupKey] || {}; // re-request if lookup was reset or params changed

      if (!_this._loadingKey && // ensure loading not in progress
      previousSearch !== undefined && (!currentData.date && prevData.date || !compareParams(_this.props.lookupParams, prevProps.lookupParams))) {
        _this.search(previousSearch, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (searchQuery) {
      var forceSuggestions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var lookupKey = undefined;
      var search = searchQuery;
      var validRequest = !!search;

      if (!validRequest) {
        var _this$props4 = _this.props,
            searchSuggestions = _this$props4.searchSuggestions,
            _value = _this$props4.value;

        var hasValue = _this.isValidValue(_value);

        if ((!hasValue || forceSuggestions) && (searchSuggestions || searchSuggestions === "")) {
          search = typeof searchSuggestions === "string" ? searchSuggestions : "";
          validRequest = true;
        }
      }

      var _this$props5 = _this.props,
          lookup = _this$props5.lookup,
          onSearch = _this$props5.onSearch;

      if (validRequest) {
        var _this$props6 = _this.props,
            _lookupRequest = _this$props6.lookupRequest,
            _lookupParams = _this$props6.lookupParams,
            lookupOptions = _this$props6.lookupOptions;

        if (lookup) {
          if (!_this.canRequestData()) {
            // flag that lookup data should be retrieved when the component is re-enabled
            _this._requestRequired = true;

            _this.setState({
              previousSearch: search
            });

            return;
          }

          var _params = _objectSpread2(_objectSpread2({}, _lookupParams), {}, {
            search: search
          });

          lookupKey = getParamsKey(_params);

          var _options = _objectSpread2(_objectSpread2({}, lookupOptions), {}, {
            key: lookupKey
          });

          _this._requestRequired = false;
          var loadingKey = _this._loadingKey = Date.now();

          _lookupRequest(lookup, _params, _options).then(function () {
            if (loadingKey === _this._loadingKey) {
              _this._loadingKey = undefined;
            }
          });
        }

        _this.setState({
          previousSearch: search
        });

        if (onSearch) onSearch(search);
      }

      if (!lookup) return;

      _this.setState({
        lookupKey: lookupKey,
        previousKey: _this.state.lookupKey
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event, value, reason) {
      if (reason !== "reset") {
        _this.debouncedSearchChange(value, !!_this.props.disableClearable);
      }

      var onInputChange = _this.props.onInputChange;
      if (onInputChange) onInputChange(event, value, reason);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      // when leaving the field repopulate suggestions
      if (_this.state.previousSearch) {
        _this.updateSearchSuggestions(_this.props.alwaysShowSuggestionsOnBlur);
      }

      var onBlur = _this.props.onBlur;
      if (onBlur) onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "filterOptions", function (x) {
      return x;
    });

    _this.debouncedSearchChange = props.debounce !== undefined && props.debounce !== 0 ? debounce(_this.search, props.debounce) : _this.search;
    _this.state = {};
    return _this;
  }

  _createClass(TypeAheadBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSearchSuggestions(this.props.alwaysShowSuggestionsOnMount);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props;
          _this$props7.lookup;
          _this$props7.lookupAction;
          _this$props7.lookupParams;
          _this$props7.lookupOptions;
          _this$props7.lookupCache;
          _this$props7.lookupRequest;
          _this$props7.debounce;
          _this$props7.searchSuggestions;
          _this$props7.alwaysShowSuggestionsOnBlur;
          _this$props7.alwaysShowSuggestionsOnMount;
          _this$props7.onSearch;
          _this$props7.requestLookupWhenDisabled;
          _this$props7.ref;
          var otherProps = _objectWithoutProperties(_this$props7, _excluded);

      var lookupKey = this.state.lookupKey;
      var loading = this.isLoading();
      var options = this.getOptions();
      return /*#__PURE__*/React.createElement(ComboBox, _extends({
        noOptionsText: lookupKey ? "No results found" : "Search...",
        filterOptions: this.filterOptions
      }, otherProps, {
        search: true,
        loading: loading,
        options: options,
        onInputChange: this.onInputChange,
        onBlur: this.onBlur
      }));
    }
  }]);

  return TypeAheadBase;
}(React.Component);

_defineProperty(TypeAheadBase, "propTypes", {
  debounce: propTypes.number,
  searchSuggestions: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  alwaysShowSuggestionsOnBlur: propTypes.bool,
  alwaysShowSuggestionsOnMount: propTypes.bool,
  onSearch: propTypes.func,
  options: propTypes.any,
  requestLookupWhenDisabled: propTypes.bool,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any,
  lookupCache: propTypes.any.isRequired,
  lookupRequest: propTypes.func.isRequired
});

var mapStateToProps = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup;
  return {
    lookupCache: lookup ? getLookupCache(state, lookup) : {}
  };
};

var actions = {
  lookupRequest: lookupRequest
};

var connectBase = function connectBase() {
  return connect(mapStateToProps, actions);
};

var TypeAheadBaseComponent = compose(withLookup$1({
  autoNamePrefix: "LookupTypeAhead/",
  required: false
}), connectBase())(TypeAheadBase);
/**
 * Wrapper around MUI Autocomplete with optional lookup data connectivity in the form of a searchable list of dynamic options
 */

var TypeAhead = function TypeAhead(props) {
  return /*#__PURE__*/React.createElement(TypeAheadBaseComponent, props);
};

TypeAhead.propTypes = {
  debounce: propTypes.number,
  searchSuggestions: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  alwaysShowSuggestionsOnBlur: propTypes.bool,
  alwaysShowSuggestionsOnMount: propTypes.bool,
  onSearch: propTypes.func,
  options: propTypes.any,
  requestLookupWhenDisabled: propTypes.bool,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any
};
TypeAhead.defaultProps = {
  lookupOptions: {
    cache: true,
    cacheLimit: 5
  },
  debounce: 200,
  alwaysShowSuggestionsOnBlur: false,
  alwaysShowSuggestionsOnMount: true,
  requestLookupWhenDisabled: false
};
var ITypeAhead = TypeAhead;

export { ITypeAhead as default };
